/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import AssetTableCell from './AssetTableCell'
import { formatDate12, isNullOrUndefined, timeSinceFromMilliseconds } from './utils'

type IdleTimeColProps = {
  value: string | null
  idleTime: Date
}

const formatValue = (value: string) => {
  return timeSinceFromMilliseconds(Number(value), 2)
}

const IdleTimeCol: React.FC<IdleTimeColProps> = ({ value, idleTime }) => {
  const displayBlank = isNullOrUndefined(value) || value === ''

  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (!displayBlank) {
    displayValue = formatValue(value)
  }
  const tooltip = idleTime ? `Idle since: ${formatDate12(idleTime)}` : ''

  return <AssetTableCell tooltip={tooltip}>{displayValue}</AssetTableCell>
}

export default IdleTimeCol
